import {
  FindPageDetailsAjax,
  FindPageDetailsRedirect,
} from './find-page-details.backend-model';
import { FindPageDetailsResult } from './find-page-details.model';

export function transformFindPageDetails(
  response: FindPageDetailsAjax | FindPageDetailsRedirect,
): FindPageDetailsResult {
  if (isFindPageDetailsAjax(response)) {
    return {
      id: response.original_url,
      details: {
        id: response.original_url,
        seoUrl: response.canonical_url,
        header: response.header,
        subheader: response.subheader,
        subheaderDescription: response.subheaderDescription,
        footer: response.footer,
        metaWorker: response.metaWorker,
        categoryId: response.category_id,
      },
    };
  }
  return {
    id: response.original_url,
    redirect: response.redirect_url,
  };
}

function isFindPageDetailsAjax(
  result: FindPageDetailsAjax | FindPageDetailsRedirect,
): result is FindPageDetailsAjax {
  return (result as FindPageDetailsAjax).canonical_url !== undefined;
}
